import React, { useMemo, useState } from 'react';
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate, useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import * as svg from '@progress/kendo-svg-icons';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import TicketGrid from '../../../../GridControls/TicketGrid';
import ConfirmMove from './ConfirmMove';
import { useReduxDispatch, useReduxSelector } from '../../../../../../redux/hooks';
import { SetSelectedActions } from '../../../../../../slices/SelectedActionsSlice';
import TicketSearch from '../../../../GridControls/TicketSearch';
import { useCurrentUserContext } from '../../../../../../context/UserContext';

const MoveTicketsModal: React.FC = () => {
    const selectedActions = useReduxSelector(state => state.selectedActionsStore.selectedActions);
    const navigate = useNavigate();
    const { ticketId } = useParams();
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const { profile: userProfile } = useCurrentUserContext();
    let { data: staffList, isLoading: staffLoading } = UserApi.useGetMentionQuery({ text: '', companyId: null });
    const { data: ticket, isLoading } = TicketApi.useGetTicketDetailsQuery({ ticketId: parseInt(ticketId) });
    const [selectedTabIndex, setTabIndex] = React.useState<number>(0);
    const [showConfirm, setShowConfirm] = React.useState(false);
    const [error, setError] = React.useState<string>();
    const [filter, setFilter] = useState<FilterDescriptor>({ operator: 'contains' })
    const filteredStaff = useMemo(() => staffList?.length && filter?.value ? filterBy(staffList?.slice(), filter) : staffList, [filter, staffList]);
    const { data: endUserTickets, isLoading: endUserTicketsLoading } = TicketApi.useGetOpenEndUserTicketsQuery(ticket?.Contact?.UId, { skip: !ticket?.Contact?.UId })
    const { data: clientTickets, isLoading: clientLoading } = TicketApi.useGetOpenTicketsQuery({ companyId: ticket?.Company_Id }, { skip: !ticket?.Company_Id })
    const [selectedTicketId, setSelectedTicketId] = useState<number>();
    const thisTicketActionsSelected = selectedActions?.filter(a => a.ticketId === ticket.ID);
    const [mergeActions, { isLoading: merging }] = TicketApi.useMergeActionsMutation();
    const dispatch = useReduxDispatch();

    //Remove the current contact's tickets from the client tickets
    let otherClientTickets = clientTickets
    if (endUserTickets && otherClientTickets) {
        const contactTicketIds = endUserTickets.map(t => t.ID);
        otherClientTickets = otherClientTickets.filter(t => !contactTicketIds.includes(t.ID));
    }
    let bindTickets = endUserTickets?.filter(e => e.ID !== ticket.ID);

    const onFilter = (event: MultiSelectFilterChangeEvent) => {
        console.log('Filter', event);
        //setStaff(filterBy(staffList?.slice(), event.filter));
        setFilter(event.filter);
    }

    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    const onWindowClose = () => {
        navigate('/ticket/' + ticketId);
    }

    const tabSelected = (e: TabStripSelectEventArguments) => {
        setTabIndex(e.selected);
    }

    const onMoveClicked = () => {

        setShowConfirm(true);


        //
    }

    const onMoveConfirmed = () => {
        setShowConfirm(false);

        //Do api stuffs
        mergeActions({ Ticket_Id: ticket.ID, Merge_Into_Ticket_Id: selectedTicketId, Merge_Action_Ids: thisTicketActionsSelected?.map(a => a.actionId) }).unwrap()
            .then((res: any) => {
                console.log('Move confirmed', res);
                if (res) {
                    //Remove the actions from the selected actions
                    let newSelectedActions = selectedActions?.filter(a => !thisTicketActionsSelected?.some(s => s.actionId === a.actionId));
                    //Update the selected actions in the store
                    dispatch(SetSelectedActions(newSelectedActions?.length > 0 ? newSelectedActions : null));

                    //navigate to the ticket
                    navigate('/ticket/' + selectedTicketId);
                }
                else {
                    if ('data' in res) setError(`Error moving ticket (code ${res.originalStatus || '<unknown>'}: ${res?.data} `)
                }
            }).catch((e) => {
                if ('data' in e) setError(`Error moving ticket (code ${e.originalStatus || '<unknown>'}: ${e?.data} `)

            });

        //Unselect the actions

        //then navigate back
        //navigate('/ticket/' + ticketId);
    }



    if (!filteredStaff || !userProfile?.Features.Call_Hierarchy) return <></>;

    return (
        <div>
            <Window modal={true} className='cool-window' minimizeButton={() => null} title={<><img width={25} height={25} src='./images/merge-white.png' />&nbsp;Move ({thisTicketActionsSelected?.length}) {userProfile?.Phrases.Action}/s  to... </>} onClose={onWindowClose} initialHeight={Math.min(850, window.innerHeight)} initialWidth={Math.min(1200, window.innerWidth)} stage={stage} onStageChange={onStageChange} >
                <div className='position-relative'>
                    {error && <div className='alert alert-danger'>{error}</div>}
                    {(isLoading || endUserTicketsLoading || clientLoading || merging) && <PartialSpinny />}
                    <TabStrip selected={selectedTabIndex} onSelect={tabSelected}>
                        <TabStripTab title={ticket.Contact_Name + 's ' + userProfile?.Phrases.CallPhrase + 's' + ' (' + bindTickets?.length + ')'}>
                            <TicketGrid data={bindTickets} selectable={true} onTicketSelected={(id) => setSelectedTicketId(id)} />
                        </TabStripTab>
                        <TabStripTab title={ticket.Company_Name + ' ' + userProfile?.Phrases.CallPhrase + 's' + ' (' + otherClientTickets?.length + ')'}>
                            <TicketGrid data={otherClientTickets} selectable={true} onTicketSelected={(id) => setSelectedTicketId(id)} />
                        </TabStripTab>
                        <TabStripTab title='Search'>
                            <TicketSearch onTicketSelected={(id) => setSelectedTicketId(id)} selectedId={selectedTicketId} />
                        </TabStripTab>
                    </TabStrip>
                    {showConfirm && <ConfirmMove actionCount={thisTicketActionsSelected?.length} targetTicketId={selectedTicketId} onCancel={() => setShowConfirm(false)} onConfirm={onMoveConfirmed} />}
                </div>
                <WindowActionsBar>
                    <Button disabled={!selectedTicketId} onClick={onMoveClicked} svgIcon={svg.arrowRightIcon} type='submit' className='justify-content-end p-2' style={{ marginTop: '20px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }}>
                        Move
                    </Button>
                    <Button fillMode='outline' onClick={() => onWindowClose()} svgIcon={svg.cancelIcon} className='justify-content-end p-2' style={{ marginTop: '20px' }}>
                        Cancel
                    </Button>
                </WindowActionsBar>
            </Window>
        </div>
    );
};

export default MoveTicketsModal;
